module.exports = __webpack_public_path__ + "img/ef87f2cc880c491a7442fe767e4254ff.9dec81a8.png";